import { t } from "i18next";

const ERROR_MESSAGES_MAP = new Map<string, string>([
  ["PA_003611", "apiErrors.userAlreadyExists"],
  ["PA_003610", "apiErrors.userAlreadyExists"],
  ["PA_006002", "apiErrors.incorrectSmsCode"],
  ["PA_000305", "apiErrors.wrongData"],
  ["PA_003614", "apiErrors.unknown"],
  ["PA_000100", "apiErrors.userNotFound"],
  ["PA_006002", "apiErrors.incorrectSmsCode"],
  ["PA_000303", "apiErrors.incorrectPassword"],
  ["PA_000304", "apiErrors.samePassword"],
  ["PA_000224", "apiErrors.importVcf"],
  ["PA_000226", "apiErrors.importVcf"],
  ["PA_000227", "apiErrors.importVcf"],
  ["PA_000229", "apiErrors.importVcf"],
  ["PA_000230", "apiErrors.importVcf"],
  ["PA_016000", "apiErrors.importVcf"],
  ["PA_016001", "apiErrors.importVcf"],
  ["PA_016004", "apiErrors.importVcf"],
]);

export const getErrorMessage = (code?: string) => {
  const errorMessage = ERROR_MESSAGES_MAP.get(code || "") || "apiErrors.unknown";
  return t(errorMessage);
};
